// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"480":"2fe73125","838":"4ebecab4"}[chunkId] + ".js";
};